ACC.deliverymode = {

	bindEditDeliveryMethodButton: function ()
	{
		$('div.checkout_summary_flow_b .change_mode_button').on("click", function ()
		{
			$.ajax({
				url: getDeliveryModesUrl,
				type: 'GET',
				dataType: 'json',
				success: function (data)
				{
					// Fill the available delivery addresses and select button
					$('#delivery_modes_dl').html($('#deliveryModesTemplate').tmpl({deliveryModes: data}));
					$('#delivery_modes_button').html($('#deliveryModeButton').tmpl({deliveryModes: data}));

					// Show the delivery modes popup
					$.colorbox({
						inline: true,
						href: "#popup_checkout_delivery_modes",
						height: false,
						overlayClose: false,
						onComplete: function ()
						{
							ACC.common.refreshScreenReaderBuffer();
						},
						onClosed: function ()
						{
							ACC.common.refreshScreenReaderBuffer();
						}
					});

					ACC.deliverymode.bindUseThisDeliveryMode();
				},
				error: function (xht, textStatus, ex)
				{
					alert("Failed to get delivery modes. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
				}
			});
			return false;
		});
	},

	bindUseThisDeliveryMode: function ()
	{
		$('#use_this_delivery_method').click(function ()
		{
			var selectedCode = $('input:radio[name=delivery]:checked').val();

			if (selectedCode)
			{
				$.ajax({
					url: setDeliveryModeUrl,
					type: 'POST',
					dataType: 'json',
					data: {modeCode: selectedCode},
					success: function (data)
					{
						if (data != null)
						{
							ACC.refresh.refreshPage(data);
							parent.$.colorbox.close();
						}
						else
						{
							alert("Failed to set delivery mode");
						}
					},
					error: function (xht, textStatus, ex)
					{
						alert("Ajax call failed while trying to set delivery mode. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
					}
				});
			}
			return false;
		});
	},
	
	refreshDeliveryMethodSection: function (data)
	{
		$('#checkout_summary_deliverymode_div').replaceWith($('#deliveryModeSummaryTemplate').tmpl(data));
		ACC.deliverymode.bindEditDeliveryMethodButton();
	},
	
	bindGiftBoxDetails: function ()
	{			
		if(typeof(giftBoxFormattedPrice1) != 'undefined'){
			$("#giftBoxCost").text(giftBoxFormattedPrice1);
		}
		if($('#IWantGiftcheckBox_0').is(':checked')){			
			$('#HYBGBREXP').attr("disabled", true);//Disable the express radio buttons
			$('#HYBUSAEXP').attr("disabled", true);// Disable the Express delivery option
			$('#HYBGBREXP').next().addClass('grey');//Disable the express radio button label
			$('#HYBUSAEXP').next().addClass('grey');//Disable the express radio button label
			$("#gift_box").toggle();
			var giftBoxes = $("#gifts").attr("value");
			var options;
			if(giftBoxes==1){
				options = ["1"];
			}
			else if(giftBoxes==2){
				options = ["1", "2"];
			}
			else if(giftBoxes==3){
				options = ["1", "2","3"];
			}else if(giftBoxes==4){
				options = ["1", "2","3", "4"]
			}
			var selectedNoOfBoxes = $("#selectedNoOfBoxes").attr("value"); 
			
			$("#GiftBoxDropDown").find('option').remove();
			 for(i=0; i < options.length; i++){
		         $("#GiftBoxDropDown").append('<option value="'+options[i]+'">'+options[i]+'</option>');
		     }
			 $("#GiftBoxDropDown").val(selectedNoOfBoxes);
			 $(".selGiftBox").toggle();
			ACC.deliverymode.calGiftBoxDetailsOnLoad();
			giftBoxSelected=true;
		}

		$("#IWantGiftcheckBox_0").change(function (e)
		{	
			$('#HYBGBREXP').next().addClass('grey');//Disable the express radio button label
			$('#HYBUSAEXP').next().addClass('grey');//Disable the express radio button label					
			$('#NEXTDAY').next().addClass('grey');//Disable the express radio button label
			$('#HYBGBREXP').attr("disabled", true);//Disable the express radio buttons
			$('#HYBUSAEXP').attr("disabled", true);// Disable the Express delivery option
			$('#NEXTDAY').attr("disabled", true);// Disable the Express delivery option
			$("#gift_box").toggle();
			var giftBoxes = $("#gifts").attr("value");
			var options;
			if(giftBoxes==1){
				options = ["1"];
			}
			else if(giftBoxes==2){
				options = ["1", "2"];
			}
			else if(giftBoxes==3){
				options = ["1", "2","3"];
			}else if(giftBoxes==4){
				options = ["1", "2","3", "4"]
			}
			$("#GiftBoxDropDown").find('option').remove();
			 for(i=0; i < options.length; i++){
		         $("#GiftBoxDropDown").append('<option value="'+options[i]+'">'+options[i]+'</option>');
		     }
			 $(".selGiftBox").toggle();			 
			ACC.deliverymode.calGiftBoxDetails();
			$("#div_Gift1").show();		
			giftBoxSelected=true;
		});
		$("#IWantGiftcheckBox_1").change(function (e)
		{
			 $('#HYBUSAEXP').next().removeClass('grey');//Disable the express radio button label
			 $('#HYBGBREXP').attr("disabled", false);// Enable the Express delivery option
			 $('#HYBUSAEXP').attr("disabled", false);// Enable the Express delivery option
			 $('#NEXTDAY').attr("disabled", false);// Enable the Express delivery option
			 $('#NEXTDAY').next().removeClass('grey');//Enable the express radio button label
			 $('#giftErrorMsg').hide();
			var giftBoxes = $("#IWantGiftcheckBox_1").attr("value");
			$("#gift_box").hide();
			$("#div_Gift1").hide();
			$("#div_Gift2").hide();
			$("#div_Gift3").hide();
			$("#div_Gift4").hide();
			$(".selGiftBox").hide();
			giftBoxSelected=false;
		});
		$('#GiftBoxDropDown').change(function(){
			ACC.deliverymode.calGiftBoxDetails();
		});			
	},
	
	calGiftBoxDetails: function ()
	{
		var $noOfBoxes = $('#noOfBoxes');
		var $totalCost = $('#totalCost')
		var value = $('#GiftBoxDropDown').val();
		var entry = Math.round(giftBoxPrice1 * value * 100) / 100;
		var noOfBoxSelected = value;

		$noOfBoxes.html("YOU HAVE ADDED:<br><b>" + value + " gift box(es)</b>")

		$totalCost.html("TOTAL COST OF GIFT BOX:<br><b>" + currency + entry + "</b>")

		var options = ["No Box", "Gift Box 1"];
		if(noOfBoxSelected==1){
			$("#div_Gift1").show();
			$("#div_Gift2").hide();
			$("#div_Gift3").hide();
			$("#div_Gift4").hide();
		}else if(noOfBoxSelected==2){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").hide();
			$("#div_Gift4").hide();
			options = ["No Box", "Gift Box 1", "Gift Box 2"];
		}else if(noOfBoxSelected==3){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").show();
			$("#div_Gift4").hide();
			options = ["No Box", "Gift Box 1", "Gift Box 2", "Gift Box 3"];
		}else if(noOfBoxSelected==4){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").show();
			$("#div_Gift4").show();
			options = ["No Box", "Gift Box 1", "Gift Box 2", "Gift Box 3", "Gift Box 4"];
		}	
		
		$(".GiftBoxSelectionDropDown").find('option').remove();
		 for(i=0; i < options.length; i++){
	         $(".GiftBoxSelectionDropDown").append('<option value="'+options[i]+'">'+options[i]+'</option>');
	     }
	},	
	calGiftBoxDetailsOnLoad: function ()
	{
		var $noOfBoxes = $('#noOfBoxes');
		var $totalCost = $('#totalCost')
		var value = $("#selectedNoOfBoxes").attr("value"); //$('#GiftBoxDropDown').val();
		var entry = Math.round(giftBoxPrice1 * value * 100) / 100;
		var noOfBoxSelected = value;
		$noOfBoxes.html("YOU HAVE ADDED:<br><b>" + value + " gift box(es)</b>")

		$totalCost.html("TOTAL COST OF GIFT BOX:<br><b>" + currency + entry + "</b>")

		var options = ["No Box", "Gift Box 1"];
		if(noOfBoxSelected==1){
			$("#div_Gift1").show();
			$("#div_Gift2").hide();
			$("#div_Gift3").hide();
			$("#div_Gift4").hide();
		}else if(noOfBoxSelected==2){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").hide();
			$("#div_Gift4").hide();
			options = ["No Box", "Gift Box 1", "Gift Box 2"];
		}else if(noOfBoxSelected==3){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").show();
			$("#div_Gift4").hide();
			options = ["No Box", "Gift Box 1", "Gift Box 2", "Gift Box 3"];
		}else if(noOfBoxSelected==4){
			$("#div_Gift1").show();
			$("#div_Gift2").show();
			$("#div_Gift3").show();
			$("#div_Gift4").show();
			options = ["No Box", "Gift Box 1", "Gift Box 2", "Gift Box 3", "Gift Box 4"];
		}	
		
		$(".GiftBoxSelectionDropDown").find('option').remove();
		 for(i=0; i < options.length; i++){
	         $(".GiftBoxSelectionDropDown").append('<option value="'+options[i]+'">'+options[i]+'</option>');
	     }
	},
	captureGiftBoxDetails: function (data)
	{
		var prodId = $(document.getElementById('selGiftBox' + data)).attr("value");
		var boxId = $(document.getElementById('GiftBoxSelectionDropDown' + data)).attr("value");
		ACC.deliverymode.removeProducts(prodId);
		if(boxId=="Gift Box 1"){
			var str = $("#prodBox1").val();
			if(str.search(prodId)==-1) {
				$("#prodBox1").val($("#prodBox1").val() + prodId + ",");
			}
		}else if(boxId=="Gift Box 2"){
			var str = $("#prodBox2").val();
			if(str.search(prodId)==-1) {
				$("#prodBox2").val($("#prodBox2").val() + prodId + ",");
			}
		}else if(boxId=="Gift Box 3"){
			var str = $("#prodBox3").val();
			if(str.search(prodId)==-1) {
				$("#prodBox3").val($("#prodBox3").val() + prodId + ",");
			}
		}else if(boxId=="Gift Box 4"){
			var str = $("#prodBox4").val();
			if(str.search(prodId)==-1) {
				$("#prodBox4").val($("#prodBox4").val() + prodId + ",");
			}
		}
	},
	removeProducts: function (tempProdId)
	{
		var prodStr = $("#prodBox1").val();
		if(prodStr.search(tempProdId)!=-1) {
			$("#prodBox1").val(prodStr.replace(tempProdId,''));
		}
		prodStr = $("#prodBox2").val();
		if(prodStr.search(tempProdId)!=-1) {
			$("#prodBox2").val(prodStr.replace(tempProdId,''));
		}
		prodStr = $("#prodBox3").val();
		if(prodStr.search(tempProdId)!=-1) {
			$("#prodBox3").val(prodStr.replace(tempProdId,''));
		}
		prodStr = $("#prodBox4").val();
		if(prodStr.search(tempProdId)!=-1) {
			$("#prodBox4").val(prodStr.replace(tempProdId,''));
		}
	},
	checkGiftWrap: function ()
	{
		if(giftBoxSelected==true){
			var selectedNoOfBoxes = $("#GiftBoxDropDown").attr("value");
			var flag = true;
			var box1 = false;
			var box2 = false;
			var box3 = false;
			var box4 = false;

			for(i=0;i<counter;i++){
				var boxId = $(document.getElementById('GiftBoxSelectionDropDown' + i)).attr("value");
				if(boxId=="Gift Box 1"){
					box1 = true;
				}else if(boxId=="Gift Box 2"){
					box2 = true;
				}else if(boxId=="Gift Box 3"){
					box3 = true;
				}else if(boxId=="Gift Box 4"){
					box4 = true;
				}
			}
			if(selectedNoOfBoxes==1){
				if(box1==false){
					flag = false;
					$("#giftErrorMsg").show();
				}
			}else if(selectedNoOfBoxes==2){
				if(box1==false || box2==false){
					flag = false;
					$("#giftErrorMsg").show();
				}
			}else if(selectedNoOfBoxes==3){
				if(box1==false || box2==false || box3==false){
					flag = false;
					$("#giftErrorMsg").show();
				}
			}else if(selectedNoOfBoxes==4){
				if(box1==false || box2==false || box3==false || box4==false){
					flag = false;
					$("#giftErrorMsg").show();
				}
			}
			return flag;
		}		
	},
	setGiftBoxDetails: function ()
	{
		if($("#prodBox1").length>0){
			var str = $("#prodBox1").val();
			for(i=0;i<counter;i++){
				var prodId = $(document.getElementById('selGiftBox' + i)).attr("value");
				if(str.search(prodId)!=-1){
					document.getElementById('GiftBoxSelectionDropDown' + i).value="Gift Box 1";
				}
			}
		}
		if($("#prodBox2").length>0){
			var str = $("#prodBox2").val();
			for(i=0;i<counter;i++){
				var prodId = $(document.getElementById('selGiftBox' + i)).attr("value");
				if(str.search(prodId)!=-1){
					document.getElementById('GiftBoxSelectionDropDown' + i).value="Gift Box 2";
				}
			}
		}
		if($("#prodBox3").length>0){
			var str = $("#prodBox3").val();
			for(i=0;i<counter;i++){
				var prodId = $(document.getElementById('selGiftBox' + i)).attr("value");
				if(str.search(prodId)!=-1){
					document.getElementById('GiftBoxSelectionDropDown' + i).value="Gift Box 3";
				}
			}
		}
		if($("#prodBox4").length>0){
			var str = $("#prodBox4").val();
			for(i=0;i<counter;i++){
				var prodId = $(document.getElementById('selGiftBox' + i)).attr("value");
				if(str.search(prodId)!=-1){
					document.getElementById('GiftBoxSelectionDropDown' + i).value="Gift Box 4";
				}
			}
		}
	},
	
	hideGiftBoxForParticularDeliveryMode: function (){	

	if ($('#HYBGBREXP').is(':checked') || $('#HYBUSAEXP').is(':checked')|| $('#NEXTDAY').is(':checked') || $('#SAT').is(':checked')) {

		$('#selectGiftBoxOption').hide();
		$("#gift_box").hide();
		$("#div_Gift1").hide();
		$("#div_Gift2").hide();
		$("#div_Gift3").hide();
		$("#div_Gift4").hide();
		$(".selGiftBox").hide();
		$("#IWantGiftcheckBox_1").attr("checked",false);
		}
	else{
		$('#giftWrapUnavailable').hide();		
		}
		
	},
	
}

$(document).ready(function ()
{
	with (ACC.deliverymode)
	{
		bindEditDeliveryMethodButton();
		bindGiftBoxDetails();
		setGiftBoxDetails();
		hideGiftBoxForParticularDeliveryMode();		
	}
});
